import PodcastColorTypes from "types/podcastColorTypes";

const podcastColors: Record<PodcastColorTypes, string> = {
  "heading-text": "#353570",
  "paragraph-text": "#4A4A4A",
  "header-background": "#353570",
  "header-text": "#FFFFFF",
  "footer-background": "#353570",
  "footer-text": "#FFFFFF",
  "playbar-background": "#087980",
  "playbar-text": "#FFFFFF",
  "body-background": "#FFFFFF",
  "featured-content-text": "#353570",
  "featured-content-badge-one": "rgba(137, 137, 199, 0.2)",
  "featured-content-badge-two": "#BEF0ED",
  "episode-container-background": "rgba(77, 61, 141, 0.8)",
  "episode-title-container-background": "#BEF0ED",
  "episode-text": "#FFFFFF",
  "episode-time-text": "#9BE7C4",
  "episode-modal-text": "#353570",
  "episode-modal-background": "#FFFFFF",
  "episode-modal-badge-one": "#9BE7C4",
  "episode-modal-badge-two": "#BEF0ED",
  "icons-background": "#BEF0ED",
  icons: "#353570",
  "media-track": "#BEF0ED",
  "media-filled-track": "#353570",
  "details-media-track": "#D6D6D6",
  "details-media-filled-track": "#9BE7C4",
  "media-tooltip-background": "#171753",
  "volume-track": "#D6D6D6",
  "volume-filled-track": "#9BE7C4"
};

export default podcastColors;
